module.exports = __webpack_public_path__ + "img/banner-ver2.b5215b3f.png";